<template>
  <!--begin::Login Sign in form-->
  <div class="login-signin">
    <div class="mb-10">
      <h2 class="font-weight-bolder">Iniciar Sesión</h2>
      <p class="">Ingresa tu usuario y contraseña:</p>
    </div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form class="form fv-plugins-bootstrap fv-plugins-framework" @submit.prevent="handleSubmit(onSubmit)">
        <div class="form-group mb-5">
          <label for="" class="d-block form-label text-white font-weight-bolder text-left mb-2">Usuario:</label>
          <InputText v-model="form.username" vid="username" name="Usuario" rules="required" placeholder="Usuario" :inputClass="'form-control h-auto rounded-pill border-0 py-4 px-8'"></InputText>
        </div>
        <div class="form-gr">
          <label for="" class="d-block form-label text-white font-weight-bolder text-left mb-2">Contraseña:</label>
          <InputText v-model="form.password" type="password" vid="password" name="Contraseña" rules="required" placeholder="Contraseña" :inputClass="'form-control h-auto rounded-pill border-0 py-4 px-8'"></InputText>
        </div>
        <div class="form-group text-center mt-10">
          <button class="btn btn-pill btn-primary font-weight-bold opacity-90 px-15 py-3" type="submit" :disabled="loading">
            <template v-if="!loading">INICIAR SESIÓN</template>
            <i v-else class="fa fa-circle-notch fa-spin m-0 p-0"></i>
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
  <!--end::Login Sign in form-->
</template>

<script>
import InputText from "../../shared/components/InputText.vue";

export default {
  components: { InputText },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      loading: false,
    };
  },
  methods: {
    async onSubmit() {
      const vm = this;
      vm.loading = true;

      try {
        const {
          data: { content },
        } = await vm.axios.post("/auth/login", {
          username: vm.form.username,
          password: vm.form.password,
        });

        const user = content.user;
        const token = content.token;

        vm.$store.dispatch("auth/login", {
          user,
          token,
        });

        vm.$router.push({ name: "inicio", query: { redirectedBy: "login" } });
      } catch (error) {
      } finally {
        vm.loading = false;
      }
    },
  },
};
</script>

<style></style>
